import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      component: () => import('@/views/search/searchIndex'),
      redirect: '/searchIndex'
    },
    {
      path: '/searchIndex',
      name: 'SerachIndex',
      component: () => import('@/views/search/searchIndex')
    },
    {
      path: '/searchResult',
      name: 'SearchResult',
      component: () => import('@/views/search/searchResult'),
      meta: {
        keepAlive: true,
        title: '招标搜索'
      }
    },
    {
      path: '/projectInfo',
      name: 'projectInfo',
      component: () => import('@/views/search/projectInfo'),
      meta: {
        keepAlive: false,
        title: '项目信息'
      }
    },
    {
      path: '/bidWinnerDetail',
      name: 'bidWinnerDetail',
      component: () => import('@/views/search/bidWinnerDetail'),
      meta: {
        requireAuth: false,
        keepAlive: false,
        title: '中标人详情'
      }
    },
    {
      path: '/tendeerDetail',
      name: 'tendeerDetail',
      component: () => import('@/views/search/tendeerDetail'),
      meta: {
        requireAuth: false,
        keepAlive: false,
        title: '招标人详情'
      }
    },
    {
      path: '/publicTradeInfo',
      name: 'publicTradeInfo',
      component: () => import('@/views/search/publicTradeInfo'),
      meta: {
        requireAuth: false,
        keepAlive: true,
        title: '公告信息'
      }
    },
    {
      path: '/tendeerInfo',
      name: 'tendeerInfo',
      component: () => import('@/views/search/tendeerInfo'),
      meta: {
        requireAuth: false,
        keepAlive: false,
        title: '基本信息'
      }
    },
    {
      path: '/tendeerMoreList',
      name: 'tendeerMoreList',
      component: () => import('@/views/search/tendeerMoreList'),
      meta: {
        requireAuth: false,
        keepAlive: false,
        title: '更多机构'
      }
    },
    {
      path: '/credit',
      name: 'credit',
      component: () => import('@/views/search/credit'),
      meta: {
        requireAuth: false,
        keepAlive: false,
        title: '信用信息'
      }
    }, {
      path: '/zgzzInfo',
      name: 'zgzzInfo',
      component: () => import('@/views/search/zgzzInfo'),
      meta: {
        requireAuth: false,
        keepAlive: false,
        title: '资格资质'
      }
    }, {
      path: '/zgzzDetail',
      name: 'zgzzDetail',
      component: () => import('@/views/search/zgzzDetail'),
      meta: {
        requireAuth: false,
        keepAlive: false,
        title: '资格资质详情'
      }
    }, {
      path: '/rank',
      name: 'rank',
      component: () => import('@/views/other/rank'),
      meta: {
        requireAuth: false,
        keepAlive: false,
        title: '龙虎榜'
      }
    },
    {
      path: '/subscriptionIndex',
      name: 'SubscrptionIndex',
      component: () => import('@/views/subscription/index'),
      meta: {
        requireAuth: false,
        keepAlive: true,
        dept: 0,
        title: '订阅'
      }
    },
    {
      path: '/subSkill',
      name: 'subSkill',
      component: () => import('@/views/subscription/subSkill'),
      meta: {
        requireAuth: false,
        title: '订阅技巧'
      }
    }, {
      path: '/subscriptionPushSet',
      name: 'subscriptionPushSet',
      component: () => import('@/views/subscription/subscriptionPushSet'),
      meta: {
        requireAuth: false,
        title: '推送设置'
      }
    }, {
      path: '/subscriptionSet',
      name: 'SubscrptionSetInfo',
      component: () => import('@/views/subscription/subscriptionSetInfo'),
      meta: {
        requireAuth: false,
        keepAlive: false,
        title: '订阅条件'
      }
    }, {
      path: '/subscriptionSetInfoPush',
      name: 'subscriptionSetInfoPush',
      component: () => import('@/views/subscription/subscriptionSetInfoPush'),
      meta: {
        requireAuth: false,
        keepAlive: false,
        title: '订阅条件'
      }
    },
    {
      path: '/attentionProject',
      name: 'AttentionProject',
      component: () => import('@/views/attention/attentionProject'),
      meta: {
        requireAuth: false,
        keepAlive: true,
        dept: 0,
        title: '我的关注'
      }
    },
    {
      path: '/feedbackCreate',
      name: 'FeedbackCreate',
      component: () => import('@/views/other/feedbackCreate'),
      meta: {
        requireAuth: false,
        title: '我要留言'
      }
    }, {
      path: '/feedbackDetail',
      name: 'FeedbackDetail',
      component: () => import('@/views/other/feedbackDetail'),
      meta: {
        requireAuth: false,
        title: '留言内容'
      }
    }, {
      path: '/feedback',
      name: 'FeedbackSearch',
      component: () => import('@/views/other/feedbackSearch'),
      meta: {
        requireAuth: false,
        keepAlive: true,
        title: '留言反馈'
      }
    }, {
      path: '/feedbackMe',
      name: 'FeedbackSearchMe',
      component: () => import('@/views/other/feedbackSearchMe'),
      meta: {
        requireAuth: false,
        keepAlive: true,
        title: '我的留言'
      }
    },
    {
      path: '/advise',
      name: 'advise',
      component: () => import('@/views/other/advise'),
      meta: {
        requireAuth: false,
        keepAlive: true,
        title: '我要反馈'
      }
    },
    {
      path: '/HelloWorld',
      name: 'HelloWorld',
      component: () => import('@/components/HelloWorld')
    },
    {
      path: '/404',
      name: 'NotFound',
      component: () => import('@/views/error-page/404_1')
    },
    { path: '*', redirect: '/404' }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js